module.exports = __webpack_public_path__ + "static/media/Bethan.da5b7635.jpg";